import React from 'react';
import Icons, { IconNames } from './icons';

const EXTERNAL_LINK = 'http://www.samskipnorthatlantic.com/export/schedules/closing-time-for-cargo';

export default class ClosingTimes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showList: false
    };
  }

  onHeaderClick = () => {
    this.setState({ showList: !this.state.showList });
  };

  getIconName = () => {
    if (this.state.showList) {
      return IconNames.SortDown;
    } else {
      return IconNames.SortUp;
    }
  };

  renderExternalLink = () => {
    let headerCss = 'header__wrapper indent__margin flex border__top__radius';
    return (
      <div className={headerCss}>
        <a className="header flex" href={EXTERNAL_LINK} target="closingtime">
          {this.props.title}
        </a>
      </div>
    );
  };

  renderHeader = () => {
    let headerCss = 'header__wrapper indent__margin flex border__top__radius';
    headerCss = this.state.showList ? headerCss : `${headerCss} border__bottom__radius`;

    return (
      <div className={headerCss}>
        <a href="javascript:void(0)" className="header flex" onClick={this.onHeaderClick}>
          {this.props.title}
          <Icons
            iconName={this.getIconName()}
            iconClassName="arrowDown"
            className="arrowDownWrapper"
          />
        </a>
      </div>
    );
  };

  renderListItem = (item, index) => {
    return (
      <div className="list__item flex" key={index}>
        <span>
          {item.localName} ({item.name})
        </span>
        <span>{item.cutoffDate}</span>
        <span>{item.cutoffDate}</span>
      </div>
    );
  };

  renderListHeader = () => {
    return (
      <div className="list__header__light">
        <span>Country</span>
        <span>LCL</span>
        <span>FCL</span>
      </div>
    );
  };

  getListItems = list => {
    return list.map((item, index) => this.renderListItem(item, index));
  };

  renderList = () => {
    if (this.state.showList) {
      let listRight = [...this.props.cutoffDates];
      let listLeft = listRight.splice(listRight.length / 2);

      const listItemsRight = this.getListItems(listRight);
      const listItemsLeft = this.getListItems(listLeft);
      return (
        <div className="list__wrapper indent__margin border__bottom__radius">
          <div className="list">
            {this.renderListHeader()}
            {listItemsLeft}
          </div>
          <div className="list">
            {this.renderListHeader()}
            {listItemsRight}
          </div>
        </div>
      );
    }
  };

  render() {
    if (this.props.displayLinkOnly) {
      return (
        <div className={`closingTimes flex ${this.props.className}`}>
          {this.renderExternalLink()}
        </div>
      );
    }

    return (
      <div className={`closingTimes flex ${this.props.className}`}>
        {this.renderHeader()}
        {this.renderList()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/closingTimes.js